import React from 'react'
import { Modal } from '@components/ui'

type MarketingDeleteCampaignModalProps = {
  show: boolean
  campaignName: string
  onCancel: () => void
  onDelete: () => void
}

const MarketingDeleteCampaignModal: React.FC<
  MarketingDeleteCampaignModalProps
> = ({ show, campaignName, onCancel, onDelete }) => {
  const titleName = campaignName.trim() || 'this campaign'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete campaign"
      description={`Are you sure you want to delete the ${titleName} campaign? This action can't be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    />
  )
}

export default MarketingDeleteCampaignModal
